import FadeTransition from './FadeTransition';

/**
 * Contains all available transitions
 *
 * @type { Object.<Transition> }
 */
const Transitions = {
  FADE: FadeTransition
};

export default Transitions;
